import { GENDER } from '@common/enums'
import { AVATAR_IMAGE } from '@lib/constants/gamification'

type Props = {
  gender: string
  name?: string
  className?: string
  image?: string
}

const { MALE, FEMALE } = GENDER
const { MALE_AVATAR, FEMALE_AVATAR, UNSPECIFIED_AVATAR } = AVATAR_IMAGE

const Avatar = ({ gender, name, className, image }: Props) => {
  const avatarImage =
    gender === MALE
      ? MALE_AVATAR
      : gender === FEMALE
      ? FEMALE_AVATAR
      : UNSPECIFIED_AVATAR
  return (
    <img
      src={image || avatarImage}
      className={`rounded-full ${className}`}
      alt={name || 'avatar image'}
    />
  )
}

export default Avatar
